import React, { useState } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { resetPassword } from '../api/api';
import { AuthLanding, AuthModal, PasswordInput, PasswordRequirements } from '../components/AuthShell';

const PASSWORD_RE = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\w\s]).{10,}$/;
const PASSWORD_HINT = 'Mínimo 10 caracteres, con mayúscula, minúscula, número y símbolo.';

function ResetPassword() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const [password, setPassword] = useState('');
  const [password2, setPassword2] = useState('');
  const [error, setError] = useState(null);
  const [done, setDone] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    if (!token) return setError('Falta el token del link. Pide uno nuevo desde "Olvidé mi contraseña".');
    if (!PASSWORD_RE.test(password)) return setError(PASSWORD_HINT);
    if (password !== password2) return setError('Las contraseñas no coinciden');

    setSubmitting(true);
    try {
      await resetPassword(token, password);
      setDone(true);
    } catch (err) {
      setError(err.response?.data?.error || 'No se pudo actualizar la contraseña');
    }
    setSubmitting(false);
  };

  return (
    <AuthLanding>
      <div className="login-cta-row">
        <p className="login-cta-hint">Define tu nueva contraseña para volver a entrar.</p>
      </div>

      <AuthModal title="Nueva contraseña" onClose={() => navigate('/')}>
        {done ? (
          <div>
            <div className="msg-banner success">Contraseña actualizada. Ya puedes iniciar sesión.</div>
            <Link to="/" className="btn btn-primary btn-block" style={{ display: 'block', textAlign: 'center', marginTop: '10px' }}>
              Ir a iniciar sesión
            </Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            {error && <div className="msg-banner error">{error}</div>}
            <div className="form-group">
              <label className="form-label">Nueva contraseña</label>
              <PasswordInput value={password} onChange={(e) => setPassword(e.target.value)} required minLength={10} autoFocus />
              <PasswordRequirements password={password} />
            </div>
            <div className="form-group">
              <label className="form-label">Confirmar contraseña</label>
              <PasswordInput value={password2} onChange={(e) => setPassword2(e.target.value)} required minLength={10} />
            </div>
            <button type="submit" disabled={submitting} className="btn btn-primary btn-block" style={{ marginBottom: '10px' }}>
              {submitting ? 'Guardando...' : 'Guardar contraseña'}
            </button>
            <p style={{ fontSize: '13px', textAlign: 'center', margin: 0 }}>
              <Link to="/">Volver a iniciar sesión</Link>
            </p>
          </form>
        )}
      </AuthModal>
    </AuthLanding>
  );
}

export default ResetPassword;
